import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as ACCOUNT_ADMINS_ROUTES } from 'domain/accountAdmins/constants';

export const NAME = `${APP_NAME}/ACCOUNT_ADMINS`;

export const REDUCER_NAME = 'accountAdmins';

export const FORM_NAME = 'CREATE_ACCOUNT_ADMIN';

export const ROUTES = {
  ROOT: `${ACCOUNT_ADMINS_ROUTES.ROOT}/create`,
};

export const PAGE_TITLE = I18n.str('createVendorCompany', 'Create Vendor Company');
export const SECTION_NAME = I18n.str('companyInfo', 'Company Info');
export const SUCCESS_MESSAGE = I18n.str(
  'companyCreatedSuccessfully',
  'Company Created Successfully',
);
